import React from 'react';
import { Link } from 'react-router-dom';
interface LimeBandCTAProps {
  text?: string;
  linkText: string;
  href: string;
}
export const LimeBandCTA: React.FC<LimeBandCTAProps> = ({
  text,
  linkText,
  href
}) => {
  return <div className="w-full bg-lime py-6 md:py-8" data-id="element-107">
      <div className="container mx-auto px-4 md:px-12" data-id="element-108">
        <div className={`flex ${text ? 'flex-col md:flex-row md:items-center md:justify-between gap-4' : 'justify-end'}`} data-id="element-109">
          {text && <p className="font-poppins font-normal text-xl md:text-2xl text-black" data-id="element-110">
              {text}
            </p>}
          <Link to="/contact" className="inline-flex items-center font-poppins font-normal text-base md:text-lg text-black hover:opacity-80 transition-opacity" data-id="element-111">
            {linkText}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-2" data-id="element-112">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-113" />
            </svg>
          </Link>
        </div>
      </div>
    </div>;
};